import { Pie, getElementsAtEvent } from "react-chartjs-2";
import { useEffect, useRef, useState } from "react";
import { countByTopicsLastXDays } from "../../../api/statistics/topic/TopicStatisticsAPI";
import RandomColor from "../../../util/RandomColor";
import { Typography } from "@mui/material";
import { Chart, Chart as ChartJS, registerables } from "chart.js";
import { singleField } from "../../../util/ArrayUtil";
import { getContentByTopic } from "../../../api/specialization/TopicSpecializationAPI";
import React from "react";
import ContentListPopup from "../../../components/popup/ContentListPopup";
import { errorNoti } from "../../../util/SnackbarMessage";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
ChartJS.register(...registerables);
function TopicPieChartWrapper() {
  const [topicData, setTopicData] = useState([]);
  const [chosenTopic, setChosenTopic] = useState("");
  const [popup, setPopup] = useState(false);
  const [sources, setSources] = useState([]);
  const chartRef = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation(["error"]);

  const onClosePopup = () => {
    setPopup(false);
    setSources([]);
  };

  const options = {
    plugins: {
      legend: { display: false },
    },
    responsive: true,
  };

  const topicLabels = singleField(topicData, "topic");

  let colors = topicLabels.map((topic) => RandomColor({ name: topic }));

  const datasets = [
    {
      label: "topicLabels",
      data: singleField(topicData, "count"),
      backgroundColor: colors,
    },
  ];

  const data = {
    labels: topicLabels,
    datasets: datasets,
  };

  const onClick = (event: any) => {
    if (
      getElementsAtEvent(chartRef.current as unknown as Chart, event).length > 0
    ) {
      const index = getElementsAtEvent(
        chartRef.current as unknown as Chart,
        event
      )[0].index;
      setPopup(true);
      console.log(index);
      var topic = topicData[index];
      setChosenTopic(topic["topic"]);
    }
  };

  useEffect(() => {
    countByTopicsLastXDays(0)
      .then((response) => setTopicData(response))
      .catch((err) => {
        var noti = errorNoti(err);
        enqueueSnackbar(t("error:" + noti.message), noti.option);
      });
  }, [colors.length]);

  useEffect(() => {
    if (chosenTopic.length > 0) {
      getContentByTopic(chosenTopic, 0)
        .then((response) => setSources(response))
        .catch((err) => {
          var noti = errorNoti(err);
          enqueueSnackbar(t("error:" + noti.message), noti.option);
        });
    }
  }, [chosenTopic]);

  return (
    <div>
      <Typography variant="h6">Số bài báo theo chủ đề - Hôm nay</Typography>
      <Pie
        ref={chartRef}
        options={options}
        data={data}
        onClick={onClick}
        style={{ marginTop: "15px" }}
      ></Pie>

      <ContentListPopup
        popup={popup}
        onClosePopup={onClosePopup}
        contents={sources}
        title={"Các bài báo gần đây về chủ đề " + chosenTopic}
      />
    </div>
  );
}

export default TopicPieChartWrapper;
